import { createTrackingPageProvider } from '@edreamsodigeo/frontend-core';

export const FLIGHT_SUMMARY_PAGE = '/BF/flights/details-extras/';
export const FLIGHT_PASSENGERS_INFO_PAGE = '/BF/flights/details-extras/';
export const FLIGHT_PAYMENT_PAGE = '/BF/flights/payment/';
export const FLIGHT_RESULTS_PAGE = '/BF/flights/results/';
export const FLEXIBILITY_BUNDLE_PAGE = '/BF/flights/fare-rules/';
export const FLASH_OFFERS_SEATS_PAYMENT_PAGE =
  '/BF/flights/flash-offers/payment/seats/';

export const FLIGHT_PASSENGERS_INFO_CATEGORY = 'flights_pax_page';
export const FLIGHT_PAYMENT_CATEGORY = 'flights_pay_page';
export const FLIGHT_RESULTS_CATEGORY = 'results_page';
export const FLEXIBILITY_BUNDLE_CATEGORY = 'flights_farerules_page';
export const FLASH_OFFERS_PAYMENT_CATEGORY = 'flights_flash-offers_pay';

export const FLIGHT_PASSENGERS_INFO_LABEL_PAGE = 'flpax';
export const FLIGHT_PAYMENT_LABEL_PAGE = 'flpay';
export const FLIGHT_FLIGHTSUMMARY_LABEL_PAGE = 'flflightsummary';

const pagesMap = {
  flight_summary: FLIGHT_SUMMARY_PAGE,
  passengersinfo: FLIGHT_PASSENGERS_INFO_PAGE,
  payment: FLIGHT_PAYMENT_PAGE,
  checkout_flight_summary_results: FLIGHT_RESULTS_PAGE,
  flash_offers_seats_payment: FLASH_OFFERS_SEATS_PAYMENT_PAGE,
};

const pageMapper = (page): string =>
  pagesMap[page] || FLIGHT_PASSENGERS_INFO_PAGE;

export const PassengersInfoPageTrackingProvider = createTrackingPageProvider({
  category: FLIGHT_PASSENGERS_INFO_CATEGORY,
  pageMapper,
  pageViewName: FLIGHT_SUMMARY_PAGE,
});

export const PaymentPageTrackingProvider = createTrackingPageProvider({
  category: FLIGHT_PAYMENT_CATEGORY,
  pageMapper,
  pageViewName: FLIGHT_PAYMENT_PAGE,
});

export const ResultsPageTrackingProvider = createTrackingPageProvider({
  category: FLIGHT_RESULTS_CATEGORY,
  pageMapper,
  pageViewName: FLIGHT_RESULTS_PAGE,
});

export const FarePlusPageTrackingProvider = createTrackingPageProvider({
  category: FLEXIBILITY_BUNDLE_CATEGORY,
  pageMapper,
  pageViewName: FLEXIBILITY_BUNDLE_PAGE,
});

export const FlashOffersSeatsPaymentPageTrackingProvider =
  createTrackingPageProvider({
    category: FLASH_OFFERS_PAYMENT_CATEGORY,
    pageMapper,
    pageViewName: FLASH_OFFERS_SEATS_PAYMENT_PAGE,
  });
